import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AccaBoostTokenValidator } from './acca-boost-token-validator.service';
import { BestOddsGuaranteedTokenValidator } from './best-odds-guaranteed/best-odds-guaranteed-token-validator.service';
import { BestOddsPickEligibilityValidator } from './best-odds-guaranteed/best-odds-pick-eligibility-validator.service';
import { BetAndGetTokenValidator } from './betandget-token-validator.service';
import { AccaBoostNotABetBuilderPickValidator } from './criteria/acca-boost-not-a-bet-builder-pick-validator.service';
import { AccaBoostNotARacePickValidator } from './criteria/acca-boost-not-a-race-pick-validator.service';
import { AccaBoostBetslipTypeStateValidator } from './criteria/acca-boost/acca-boost-betslip-type-state-validator.service';
import { AccaBoostCompetitionsValidator } from './criteria/acca-boost/acca-boost-competitions-validator.service';
import { AccaBoostGridGroupsValidator } from './criteria/acca-boost/acca-boost-grid-groups-validator.service';
import { AccaBoostMinOddsValidator } from './criteria/acca-boost/acca-boost-min-odds-validator.service';
import { AccaBoostMinimumLegsValidator } from './criteria/acca-boost/acca-boost-minimum-legs-validator.service';
import { AccaBoostSlipTypeValidator } from './criteria/acca-boost/acca-boost-slip-type-validator.service';
import { AccaBoostSportsValidator } from './criteria/acca-boost/acca-boost-sports-validator.service';
import { DayOfWeekValidator } from './criteria/best-odds-guaranteed/day-of-week-validator.service';
import { SportsBestOddsGuaranteeValidator } from './criteria/best-odds-guaranteed/sports-validator.service';
import { TimeOfDayValidator } from './criteria/best-odds-guaranteed/time-of-day-validator.service';
import { BetAndGetBetBuilderValidator } from './criteria/bet-and-get/bet-and-get-bet-builder-validator.service';
import { BetAndGetMinimumLegsValidator } from './criteria/bet-and-get/bet-and-get-minimum-legs-validator.service';
import { BetAndGetSlipTypeValidator } from './criteria/bet-and-get/bet-and-get-slip-type-validator.service';
import { BetBuilderValidator } from './criteria/bet-builder-validator.service';
import { BetslipTypeStateValidator } from './criteria/betslip-type-state-validator.service';
import { CompetitionsValidator } from './criteria/competitions-validator.service';
import { DayOfWeekValidatorService } from './criteria/day-of-week-validator.service';
import { ExpiryDateValidator } from './criteria/expiry-date-validator.service';
import { FixturesValidator } from './criteria/fixtures-validator.service';
import { ForbiddenFreebetValidator, ForbiddenOddsBoostValidator, ForbiddenRiskFreeValidator } from './criteria/forbidden-entities-validator.service';
import { GameTypeValidator } from './criteria/game-type-validator.service';
import { MarketParametersValidator } from './criteria/market-parameters-validator.service';
import { MarketTemplatesValidator } from './criteria/market-templates-validator.service';
import { MarketsValidator } from './criteria/markets-validator.service';
import { MaxOddsValidator } from './criteria/max-odds-validator.service';
import { MaximumStakeValidator } from './criteria/maximum-stake-validator.service';
import { MeetingsValidator } from './criteria/meetings-validator.service';
import { MinimumLegsValidator } from './criteria/minimum-legs-validator.service';
import { MinimumStakeValidator } from './criteria/minimum-stake-validator.service';
import { MultiSlipTypeValidator } from './criteria/multi-slip-type-validator.service';
import { NotEachWayValidator } from './criteria/not-each-way-validator.service';
import { NotParticipantBetValidator } from './criteria/not-participant-bet-validator.service';
import { NotSystemBetValidator } from './criteria/not-system-bet-validator.service';
import { OptionValidator } from './criteria/option-validator.service';
import { OverallOddsValidator } from './criteria/overall-odds-validator.service';
import { SelectionLevelMaxOddsValidator } from './criteria/selection-level-max-odds-validator.service';
import { SelectionOddsValidator } from './criteria/selection-odds-validator.service';
import { SlipTypeValidator } from './criteria/slip-type-validator.service';
import { SportsValidator } from './criteria/sports-validator.service';
import { StartDateValidator } from './criteria/start-date-validator.service';
import { TeaserRewardTypeValidator } from './criteria/teaser-reward-type-validator.service';
import { TimeOfDayValidatorService } from './criteria/time-of-day-validator.service';
import { FreebetTokenValidator } from './freebet-token-validator.service';
import { OddsBoostTokenValidator } from './odds-boost-token-validator.service';
import { RiskFreeTokenValidator } from './risk-free-token-validator.service';

@NgModule({
    declarations: [],
    imports: [CommonModule],
    providers: [
        AccaBoostCompetitionsValidator,
        AccaBoostGridGroupsValidator,
        AccaBoostMinOddsValidator,
        AccaBoostSlipTypeValidator,
        AccaBoostSportsValidator,
        AccaBoostNotARacePickValidator,
        AccaBoostTokenValidator,
        AccaBoostNotABetBuilderPickValidator,
        AccaBoostBetslipTypeStateValidator,
        FreebetTokenValidator,
        OddsBoostTokenValidator,
        RiskFreeTokenValidator,
        CompetitionsValidator,
        StartDateValidator,
        ExpiryDateValidator,
        DayOfWeekValidatorService,
        TimeOfDayValidatorService,
        FixturesValidator,
        GameTypeValidator,
        NotParticipantBetValidator,
        SlipTypeValidator,
        SportsValidator,
        MaximumStakeValidator,
        MinimumLegsValidator,
        BetslipTypeStateValidator,
        NotEachWayValidator,
        MeetingsValidator,
        ForbiddenFreebetValidator,
        ForbiddenOddsBoostValidator,
        ForbiddenRiskFreeValidator,
        BestOddsGuaranteedTokenValidator,
        BestOddsPickEligibilityValidator,
        DayOfWeekValidator,
        TimeOfDayValidator,
        SportsBestOddsGuaranteeValidator,
        NotSystemBetValidator,

        BetAndGetTokenValidator,
        OverallOddsValidator,
        SelectionOddsValidator,
        BetAndGetBetBuilderValidator,
        MinimumStakeValidator,
        BetBuilderValidator,
        BetAndGetMinimumLegsValidator,
        AccaBoostMinimumLegsValidator,
        BetAndGetSlipTypeValidator,
        TeaserRewardTypeValidator,
        MultiSlipTypeValidator,
        MaxOddsValidator,
        SelectionLevelMaxOddsValidator,
        OptionValidator,
        MarketsValidator,
        MarketTemplatesValidator,
        MarketParametersValidator,
    ],
})
export class RewardTokensValidatorsModule {}
